/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { Autocomplete, Button, Stack, TextField } from "@mui/material";

import { useReportsActions, useReportsMetaSelector } from "store";

interface Props {
  filter: string;
  title: string;
  onCancel: () => void;
  onSubmit: (data: { title: string; filter: string }) => void;
}

export const Menu: React.FC<Props> = ({ filter, title, onCancel, onSubmit }) => {
  const [filterValue, setFilterValue] = useState<string>(filter);
  const [titleValue, setTitleValue] = useState<string>(title);

  const { KPIFields } = useReportsMetaSelector();
  // const { setCubicAction } = useReportsActions();

  const handleSubmit = () => {
    onSubmit({ title: titleValue, filter: filterValue });
  };

  const disabled = !filterValue || !titleValue;

  return (
    <Stack
      sx={{
        bgcolor: "white",
        p: "15px 10px",
        boxShadow: "sm",
        borderRadius: 5,
        gap: "15px",
        maxWidth: 250,
        minWidth: 250,
        minHeight: 170
      }}
    >
      <Autocomplete
        options={KPIFields}
        onChange={(_, option) => {
          setFilterValue(option);
          setTitleValue(option);
        }}
        value={filterValue}
        disableClearable
        renderInput={(params) => <TextField {...params} label="Value" size="small" />}
        limitTags={2}
      />
      <TextField
        value={titleValue}
        label="Rename"
        variant="outlined"
        onChange={(event) => setTitleValue(event.target.value)}
      />
      <Stack sx={{ flexDirection: "row", justifyContent: "flex-end", gap: "10px" }}>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" disabled={disabled} onClick={handleSubmit}>
          Apply
        </Button>
      </Stack>
    </Stack>
  );
};
